import React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const CompletedIcon = (props: SvgProps) => <Svg
  width={20}
  height={20}
  viewBox='0 0 20 20'
  fill='none'
>
  <Path
    d='M3.75 10.625L8.75 15.625L16.25 4.375'
    stroke={props.color ?? '#005608'}
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default CompletedIcon;
